import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IProtocoloReusoState } from './types';

export const INITIAL_STATE: IProtocoloReusoState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IProtocoloReusoState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PROTOCOLO_REUSO_REQUEST: {
				break;
			}
			case Types.PROTOCOLO_REUSO_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.PROTOCOLO_REUSO_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.PROTOCOLO_REUSO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
